<template>
  <div class="footer-content">
    <div>
      <span class="ft-15" @click="toPolicy">Privacy Policy</span>
      <span class="ft-15 line">|</span>
      <span class="ft-15" @click="toService">Terms of Service</span>
    </div>
    <div class="ft-15-s">{{ config.copyright }}</div>
    <div class="ft-15-s">Content Us: {{ config.email }}</div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config
    }
  },
  methods: {
    toPolicy() {
      window.open(config.policy, "newW");
    },
    toService() {
      window.open(config.term, "newW");
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-content{
  width: 100%;
  height: 80px;
  background: #000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.ft-15{
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
}
.ft-15-s{
  font-size: 15px;
  margin-left: 60px;
}
.line{
  margin: 0 10px;
}
@media screen and (max-width: 768px) {
  .footer-content{
    flex-direction: column;
    height: 130px;
  }
  .ft-15-s{
    margin-left: 0;
  }
}
</style>